/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'actions-navigation-chevron-down': {
    width: 20,
    height: 20,
    viewBox: '0 0 20 20',
    data: '<path pid="0" fill-rule="evenodd" d="M10 13.75L3.75 7.5l.875-.875L10 12l5.375-5.375.875.875z"/>'
  }
})
